
























import NavList from '@/components/nav-list.vue';
import {routes} from '@/router';
import UiHeader from '@/views/header.vue';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import {Component, Watch} from 'vue-property-decorator';
import {RouteConfig} from 'vue-router';

Vue.use(VueClipboard as any);
@Component({
  components: {
    UiHeader,
    NavList
  }
})
export default class App extends Vue {
  private componentName: string = null;

  get isDemo() {
    return this.$route.path.startsWith('/demo');
  }

  get routersName() {
    return routes.find(it => it.name === 'site').children;
  }

  @Watch('$route', {immediate: true})
  public routeChanged(route: RouteConfig) {
    if (route.path.startsWith('/mobile-components')) {
      this.componentName = 'm-' + route.path.replace('/mobile-components/', '');
    } else {
      this.componentName = null;
    }
  }

}
